export const getCheckoutUrl = ({
  zoneId,
  checkoutKey,
  mode: checkoutMode,
  storeKey,
}: {
  zoneId: string;
  checkoutKey: string;
  mode: "sku-in-box" | "autonomous";
  storeKey: string;
}): string => `/stores/${storeKey}/zones/${zoneId}/${checkoutMode}/checkout/${checkoutKey}`;

export const getMainUrl = ({
  zoneId,
  storeKey,
  mode: checkoutMode,
}: {
  zoneId: string;
  storeKey: string;
  mode: "sku-in-box" | "autonomous";
}): string => `/stores/${storeKey}/zones/${zoneId}/${checkoutMode}`;

export const getGuideUrl = ({
  zoneId,
  storeKey,
  mode: checkoutMode,
}: {
  zoneId: string;
  storeKey: string;
  mode: "sku-in-box" | "autonomous";
}): string => `/stores/${storeKey}/zones/${zoneId}/${checkoutMode}/guide`;
